import React, { FC, useState } from "react";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import TableTab from "../../../tabs/table-tab";
import { DEF_PG_SIZE_WIZARD } from "../../../../constants/maximum-page-size";
import { useFormikContext } from "formik";
import { getEventTypes } from "../../../../services/eventTypeService";
import EventTypeSearch from "../../../../models/search/EventTypeSearch";
import EventTypeColumns from "../../../../models/ColumnDefinitions/EventTypeColumns";
import { toast } from "react-toastify";
import { MAX_RECORDS } from "../../../../constants/notification-key";

interface Props {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription: (discription: string) => void;
}

const EventSelectionStep: FC<Props> = ({onBack, onNext, setSideBarStepDescription}) => {
    const { translate } = useLocale(); 
    const { setFieldValue, values } = useFormikContext<any>();
    const [selectedIds, setSelectedIds] = useState<string[]>(values.eventSelectionId || []);

    const onLocalNext = (event: any) => {
        if (selectedIds.length > 0) {
            onNext({ ...event});
            setFieldValue("eventSelectionId", selectedIds);
            setSideBarStepDescription(`${selectedIds.length} ${translate.byKey(TranslationKeys.selected)}`)
        }
    }

    const itemSelected = (selectedItem: any) => {
        if (selectedItem) {
            setFieldValue("eventSelectionId", selectedIds);
        }
    }

    const validateSelectedIds = (ids: string[]) => {
        if (ids.length >= MAX_RECORDS) {
            toast.error(translate.byKey(TranslationKeys.aMaximimumOf20RecordsCanBeSelected));
            setSelectedIds([...selectedIds])
        } else {
            setSelectedIds([...ids])
        }
    }

    return (<div className="pt-3 pr-3 pl-3 h-full" style={{ height: "100%", overflow:"auto" }}>
        <TableContextProvider
            usePagination
            useTable
            useFilter
            useSearch
            dataMethod={(listParameters) => getEventTypes(translate, listParameters)}
            tableDescriptor={EventTypeColumns}
            searchDescriptor={EventTypeSearch}
            maxPageSize={DEF_PG_SIZE_WIZARD}
            canExportReport={false}>
            <TableTab
                title={translate.byKey(TranslationKeys.selectTheEvent)}
                onRowClicked={itemSelected}
                tableId={'eventSelectionTable'}
                selectedIds={selectedIds}
                setSelectedIds={validateSelectedIds}
                style={{ maxHeight: "calc(100% - 70px)" }}
                cyName="eventSelectionStep"
            />
        </TableContextProvider>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${selectedIds.length > 0 ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    onClick={e => onLocalNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>

    </div>)
}

export default EventSelectionStep;
